module.exports = __webpack_public_path__ + "static/media/stamp.32c6b3fe.svg";


//////////////////
// WEBPACK FOOTER
// ./src/newDropshipperApp/component/modalConductor/topCategoriesModal/images/stamp.svg
// module id = 2131
// module chunks = 0